import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { getPartByID } from '@reducers/parts';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface PartDetailsJobsTimelineProps {}

const PartDetailsJobsTimelineComponent: FC<PartDetailsJobsTimelineProps> = ({
  clearTools,
  getTools,
  updateHeaderConfig,
  getProductionBatchByPart,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    updateHeaderConfig,
    getProductionBatchByPart,
    getPartByID,
    operationsSearch,
    getAllJobs: false,
  });

  return (
    <DetailsPageWrapper title={title.job}>
      <MultiMachineTimeline />
    </DetailsPageWrapper>
  );
};

const PartDetailsJobsTimeline = connect(null, {
  clearTools,
  getNCFileByPartId,
  getTools,
  updateHeaderConfig,
  getProductionBatchByPart,
  getPartByID,
  operationsSearch,
})(PartDetailsJobsTimelineComponent);

export { PartDetailsJobsTimeline };
